// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  font-size: 17px;
  text-align: center;
  padding-inline: 0;
  margin-top: 7px;
}

h4 {
  font-size: 17px;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-pre-geo-info/popover-pre-geo-info.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAEF","sourcesContent":["ion-title {\r\n  font-size: 17px;\r\n  text-align: center;\r\n  padding-inline: 0;\r\n  margin-top: 7px;\r\n}\r\nh4 {\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
